/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OperatorDTO } from './OperatorDTO';
import {
    OperatorDTOFromJSON,
    OperatorDTOFromJSONTyped,
    OperatorDTOToJSON,
} from './OperatorDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface OperatorPageDTO
 */
export interface OperatorPageDTO {
    /**
     * 
     * @type {Array<OperatorDTO>}
     * @memberof OperatorPageDTO
     */
    content?: Array<OperatorDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof OperatorPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OperatorPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OperatorPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof OperatorPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof OperatorPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof OperatorPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof OperatorPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the OperatorPageDTO interface.
 */
export function instanceOfOperatorPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperatorPageDTOFromJSON(json: any): OperatorPageDTO {
    return OperatorPageDTOFromJSONTyped(json, false);
}

export function OperatorPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(OperatorDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function OperatorPageDTOToJSON(value?: OperatorPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(OperatorDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

